//Global variable for spellchecker
var l;

function signatureCapture(prop) {
	var canvas = document.getElementById("signatureFromMouse"+prop.PropertyName);
	if(canvas)
	{
		var context = canvas.getContext("2d");

		if (!context) {
			throw new Error("Failed to get canvas' 2d context");
		}
		canvas.width = canvas.clientWidth ;
		canvas.height = canvas.clientHeight ;
		
		context.fillStyle = "#fff";
		context.strokeStyle = "#444";
		context.lineWidth = 1.2;
		context.lineCap = "round";
	
		context.fillRect(0, 0, canvas.width, canvas.height);
	
		context.fillStyle = "#3a87ad";
		context.strokeStyle = "#3a87ad";
		context.lineWidth = 1;
		context.moveTo(20,220);
		context.lineTo(454,220);
		context.stroke();
	
		context.fillStyle = "#fff";
		context.strokeStyle = "#444";
		
		
		prop.disableSave = true;
		prop.pixels = [];
		prop.cpixels = [];
		prop.xyLast = {};
		prop.xyAddLast = {};
		prop.calculate = false;
		//functions
		{
			function remove_event_listeners() {
				canvas.removeEventListener('mousemove', on_mousemove, false);
				canvas.removeEventListener('mouseup', on_mouseup, false);
				canvas.removeEventListener('touchmove', on_mousemove, false);
				canvas.removeEventListener('touchend', on_mouseup, false);
	
				document.body.removeEventListener('mouseup', on_mouseup, false);
				document.body.removeEventListener('touchend', on_mouseup, false);
			}
	
			function get_board_coords(e) {
				var x, y;
	
				if (e.changedTouches && e.changedTouches[0]) {
					var rect = canvas.getBoundingClientRect();
					var touch=e.changedTouches[0];
					x = touch.pageX - rect.left;
					y = touch.pageY - rect.top;		
				} else if (e.layerX || 0 == e.layerX) {
					x = e.layerX;
					y = e.layerY;
				} else if (e.offsetX || 0 == e.offsetX) {
					x = e.offsetX;
					y = e.offsetY;
				}
				return {
					x : x,
					y : y
				};
			};
	
			function on_mousedown(e) {
				e.preventDefault();
				e.stopPropagation();
                prop.changesSignature=true;
				canvas.addEventListener('mousemove', on_mousemove, false);
				canvas.addEventListener('mouseup', on_mouseup, false);
				canvas.addEventListener('touchmove', on_mousemove, false);
				canvas.addEventListener('touchend', on_mouseup, false);
	
				document.body.addEventListener('mouseup', on_mouseup, false);
				document.body.addEventListener('touchend', on_mouseup, false);
	
				empty = false;
				var xy = get_board_coords(e);
				context.beginPath();
				prop.pixels.push('moveStart');
				context.moveTo(xy.x, xy.y);
				prop.pixels.push(xy.x, xy.y);
				prop.xyLast = xy;
			};
	
			function on_mousemove(e, finish) {
				e.preventDefault();
				e.stopPropagation();
                prop.changesSignature=true;
				var xy = get_board_coords(e);
				var xyAdd = {
					x : (prop.xyLast.x + xy.x) / 2,
					y : (prop.xyLast.y + xy.y) / 2
				};
	
				if (prop.calculate) {
					var xLast = (prop.xyAddLast.x + prop.xyLast.x + xyAdd.x) / 3;
					var yLast = (prop.xyAddLast.y + prop.xyLast.y + xyAdd.y) / 3;
					prop.pixels.push(xLast, yLast);
				} else {
					prop.calculate = true;
				}
	
				context.quadraticCurveTo(prop.xyLast.x, prop.xyLast.y, xyAdd.x, xyAdd.y);
				prop.pixels.push(xyAdd.x, xyAdd.y);
				context.stroke();
				context.beginPath();
				context.moveTo(xyAdd.x, xyAdd.y);
				prop.xyAddLast = xyAdd;
				prop.xyLast = xy;
	
			};
	
			function on_mouseup(e) {
                prop.changesSignature=true;
				remove_event_listeners();
				prop.disableSave = false;
				context.stroke();
				prop.pixels.push('e');
				prop.calculate = false;
			};
	
		}//end
	
		canvas.addEventListener('mousedown', on_mousedown, false);
		canvas.addEventListener('touchstart', on_mousedown, false);
	}
}

function formatBlockCode(){
    document.querySelectorAll('pre').forEach((block) => { 
        hljs.highlightBlock(block); 
    }); 
}

function getHammerInstance(id,globalCount)
{
    var element = document.getElementById('inline_preview_'+id);
    if(element)
    {
        element.id='inline_preview_'+id+"_"+globalCount;
        return new Hammer(element);
    }
    return undefined;
}
